import { Helmet } from 'react-helmet';

// sections
import Login from '../sections/auth/Login';

const LoginPage = () => {
  return (
    <>
      <Helmet>
        <title> Login | Safepoint</title>
      </Helmet>

      <Login />
    </>
  );
};

export default LoginPage;
